import styled, { css, keyframes } from 'styled-components';
import { GYPSUM, KOALA, OLAF, HEFFALUMP, SLINKY } from 'HubStyleTokens/colors'; // use constants

const DEFAULT = 'default';
const BLANK = 'blank';
const SHADE = 'on-shade';
const DARK = 'on-dark'; // animation constants

const DURATION = '1s';
const TIMING_FUNC = 'linear';
const DELAY = '0s';
const ITERATION = 'infinite';
const FILL_MODE = 'forwards';
const POSITION_X = 700;
const SHIMMER_ANIMATION = keyframes(["0%{background-position:-", "px 0}100%{background-position:", "px 0}"], POSITION_X, POSITION_X);
const COLOUR_MAPPINGS = {
  [DEFAULT]: {
    primary: GYPSUM,
    secondary: KOALA
  },
  [SHADE]: {
    primary: KOALA,
    secondary: GYPSUM
  },
  [DARK]: {
    primary: HEFFALUMP,
    secondary: SLINKY
  }
};
const BLANK_BACKGROUND = `
  background: ${OLAF};
`;

const makeGradientBackground = ({
  primary,
  secondary
}) => `
  background: ${primary};
  background: linear-gradient(to right, ${primary}, ${secondary} 20%, ${primary} 40%);
  background-size: 1200px;
`;

const animation = css(["animation:", " ", " ", " ", " ", " ", ";"], SHIMMER_ANIMATION, DURATION, TIMING_FUNC, DELAY, ITERATION, FILL_MODE);
export const isNumber = value => typeof value === 'number';
export const getSize = value => isNumber(value) ? `${value}px` : value;

const getColourPattern = useOption => COLOUR_MAPPINGS[useOption];

const getBackground = ({
  use
}) => use === BLANK ? BLANK_BACKGROUND : makeGradientBackground(getColourPattern(use));

const SkeletonBase = styled.div.withConfig({
  displayName: "SkeletonBase",
  componentId: "pijz7x-0"
})(["margin:", ";padding:", ";", ";", ";"], ({
  margin
}) => margin ? getSize(margin) : undefined, ({
  padding
}) => padding ? getSize(padding) : undefined, ({
  use
}) => getBackground({
  use
}), ({
  use
}) => use !== BLANK && animation);
export default SkeletonBase;